export const preloadImage = async (url: string): Promise<void> => {
  const image = document.createElement("img");
  image.src = url;

  return new Promise<void>(resolve => {
    image.onload = () => resolve();
    image.onerror = () => resolve();
  });
};
